import React, { useContext } from "react";
import { useQuery } from "@apollo/client";
import DeleteButton from "../components/DeleteButton";
import MUIDataTable from "mui-datatables";
import AddFarmModal from "../components/AddFarmModal";
import { AuthContext } from "../context/auth";
import { FETCH_FARM_SYSTEM_QUERY } from "../util/graphql";
const TableAttributes = require("../variables/TableAttributes.js");

function FarmSystem(props) {
  const user = useContext(AuthContext);
  // let newData = [{}];
  let edit;
  const { loading, error, data } = useQuery(FETCH_FARM_SYSTEM_QUERY);

  function deletePostCallback() {
    window.location.reload(false);
  }

  if (loading) return "Loading...";
  if (error) return `Error! ${error.message}`;

  if (user) {
    // let userId = user.id;
    edit = data.getFarmSystem
      // .filter((o) => o.user === userId)
      .map((o) => ({
        ...o,
        fangraphs: o.fangraphs ? <a href={o.fangraphs}> Player Page </a> : "",
        delete: <DeleteButton postId={o.id} callback={deletePostCallback} />,
      }))
      .sort(function (a, b) {
        return b.fv - a.fv;
      });
    // console.log(edit);
  }

  if (data) {
  }

  return (
    <div>
      <div style={{ paddingTop: 16, paddingBottom: 16 }}>
        <AddFarmModal />
      </div>
      {user && (
        <MUIDataTable
          title={"Minor League System"}
          data={edit}
          columns={TableAttributes.farm_columns}
          options={TableAttributes.spec_options}
        />
      )}
    </div>
  );
}

export default FarmSystem;
